// Immediately invoked async function to avoid polluting global scope
(async () => {
	// Set up debug flags and test identifiers
	const debugMode = 1,
		testId = "GLX-022",
		logInfo = testId + " -->",
		variation = 1;

	try {
		// Check if code has already run to prevent duplicate execution
		if (!document.documentElement.classList.contains(`${testId}_var_${variation}`)) {
			// Add identifier classes to document root
			document.documentElement.classList.add(`${testId}_var_${variation}`);
			document.documentElement.classList.add(`${testId}_var`);

			// Handle Tampermonkey's window scope differences
			let _window = window;
			if (typeof unsafeWindow !== "undefined") _window = unsafeWindow;

			// Initialise Convert queue if it doesn't exist
			_window._conv_q = _window._conv_q || [];

			// Check if user is on mobile device
			const isMobile = window.matchMedia("(max-width: 749px)").matches;

			// Helper function to wait for DOM elements to appear
			const waitForElement = (selector) => {
				try {
					return new Promise((resolve) => {
						try {
							// Return immediately if element exists
							if (document.querySelector(selector)) {
								resolve(document.querySelector(selector));
								return;
							}

							// Otherwise watch DOM for element to appear
							const observer = new MutationObserver(() => {
								try {
									if (document.querySelector(selector)) {
										observer.disconnect();
										resolve(document.querySelector(selector));
									}
								} catch (err) {
									if (debugMode) console.error(logInfo, err.message);
								}
							});

							observer.observe(document.documentElement, {
								childList: true,
								subtree: true
							});
						} catch (err) {
							if (debugMode) console.error(logInfo, err.message);
						}
					});
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			};

			// Helper function to send Convert.com tracking events
			const sendConvertEvent = (number, label = "") => {
				try {
					_conv_q.push(["triggerConversion", number]);

					if (debugMode) console.log(logInfo, "Convert event sent:", number, label);
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			};

			// Helper function to send Google Analytics events
			const sendGAEvent = (category, pureEvent = false) => {
				try {
					let _category = `${pureEvent ? "" : "hd_"}${category.toLowerCase().trim().replace(/ /gi, "_")}`;

					if (typeof _window.gtag === "undefined") {
						_window.dataLayer = _window.dataLayer || [];
						_window.gtag = function () {
							_window.dataLayer.push(arguments);
						};
					}

					_window.gtag("event", _category, {
						send_to: "G-2FT1FSRP5J"
					});

					if (debugMode) console.log(logInfo, "Sent GA event:", _category);
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			};

			// HTML template for quick filters section
			const quickFiltersHTML = `
				<div class="${testId}_quick-filters">
					<div class="${testId}_quick-filters-flex-wrapper">
						<div class="${testId}_quick-filters-title">QUICK FILTERS</div>
						<div class="${testId}_quick-filters-buttons">
							<button class="${testId}_quick-filter-btn" data-filter="availability">AVAILABILITY</button>
							<button class="${testId}_quick-filter-btn" data-filter="size">SIZE</button>
							<button class="${testId}_quick-filter-btn" data-filter="colour">COLOUR</button>
						</div>
					</div>
				</div>
			`;

			// Function to apply selected filters and update product listing
			const applyFilter = async (quickFiltersContainer, mainCollectionContainer, filterActionInfo) => {
				try {
					// Get current URL parameters
					const currentParams = new URLSearchParams(window.location.search);
					let filterParams = new URLSearchParams();

					// Preserve non-filter URL parameters
					currentParams.forEach((value, key) => {
						try {
							if (!key.startsWith("filter.")) {
								filterParams.append(key, value);
							}
						} catch (err) {
							if (debugMode) console.error(logInfo, err.message);
						}
					});

					// Collect all selected filter values
					const selectedFilters = quickFiltersContainer.querySelectorAll(`details input:checked`);
					const selectedFilterNames = new Set();

					selectedFilters.forEach((filter) => {
						try {
							filterParams.append(filter.name, filter.value);
							selectedFilterNames.add(filter.name);
						} catch (err) {
							if (debugMode) console.error(logInfo, err.message);
						}
					});

					// Keep existing filters that aren't being modified
					currentParams.forEach((value, key) => {
						try {
							if (key.startsWith("filter.")) {
								const filterType = key.split(".").slice(0, 2).join(".");

								if (!selectedFilterNames.has(filterType) && (filterActionInfo.selected || key !== filterActionInfo.name)) {
									filterParams.append(key, value);
								}
							}
						} catch (err) {
							if (debugMode) console.error(logInfo, err.message);
						}
					});

					// Update URL without page reload
					const newURL = `${window.location.pathname}?${filterParams.toString()}`;
					window.history.pushState({}, "", newURL);

					// Add section ID if needed
					if (!filterParams.has("section_id")) {
						filterParams.append("section_id", mainCollectionContainer.id.replace("shopify-section-", ""));
					}

					const filterURL = `https://galxboy.co.za${window.location.pathname}?${filterParams.toString()}`;

					// Fetch and update filtered content
					const response = await fetch(filterURL);
					const html = await response.text();
					const parser = new DOMParser();
					const doc = parser.parseFromString(html, "text/html");
					const newContent = doc.querySelector("body");

					if (newContent) {
						mainCollectionContainer.innerHTML = newContent.innerHTML;
					}
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			};

			// Helper function to close the filter drawer
			const closeFilterDrawer = () => {
				try {
					const clickBody = () => {
						try {
							if (document.querySelector("body > #facets-drawer")) {
								document.body.click();
								setTimeout(clickBody, 100);
							} else {
								document.body.classList.remove(`${testId}_hide-filters`);
							}
						} catch (err) {
							if (debugMode) console.error(logInfo, err.message);
						}
					};

					clickBody();
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			};

			// Main function to add quick filters to the page
			const addQuickFilters = (mainCollectionContainer) => {
				try {
					const collectionContainer = mainCollectionContainer.querySelector(".collection");

					// Only add quick filters if they don't already exist
					if (!mainCollectionContainer.querySelector(`.${testId}_quick-filters`) && collectionContainer) {
						// Insert quick filters HTML
						collectionContainer.insertAdjacentHTML("beforebegin", quickFiltersHTML);

						const quickFiltersContainer = document.querySelector(`.${testId}_quick-filters`);
						const quickFiltersButtons = quickFiltersContainer.querySelectorAll(`.${testId}_quick-filter-btn`);

						// Get reference to main filter button
						const filterButton = document.querySelector('.collection-toolbar__button-list button[aria-controls="facets-drawer"]');

						// Add click handlers to quick filter buttons
						quickFiltersButtons.forEach((button) => {
							button.addEventListener("click", async () => {
								try {
									// Track quick filters - main buttons interaction
									sendConvertEvent(100480682, "[GLX-022] Quick Filter Click");
									sendGAEvent("[GLX-022] Quick Filter Click");

									// Remove any existing filter details
									const details = quickFiltersContainer.querySelector("details.accordion__disclosure");
									if (details) {
										details.remove();
									}

									// Handle button active states
									if (button.classList.contains(`${testId}_quick-filter-btn-active`)) {
										button.classList.remove(`${testId}_quick-filter-btn-active`);
										return;
									} else {
										quickFiltersButtons.forEach((btn) => {
											try {
												btn.classList.remove(`${testId}_quick-filter-btn-active`);
											} catch (err) {
												if (debugMode) console.error(logInfo, err.message);
											}
										});
										button.classList.add(`${testId}_quick-filter-btn-active`);
									}

									// Open filter drawer if needed
									if (!document.querySelector("body > #facets-drawer") && filterButton) {
										document.body.classList.add(`${testId}_hide-filters`);
										filterButton.click();
									}

									// Wait for filter drawer and find matching filter section
									const filterDrawer = await waitForElement("body > #facets-drawer");
									const filterType = button.getAttribute("data-filter");
									const filterSections = filterDrawer.querySelectorAll("summary");
									let filterSection = null;

									filterSections.forEach((section) => {
										if (section.textContent.trim().toLowerCase() === filterType) {
											filterSection = section;
										}
									});

									if (filterSection) {
										// Clone and add filter section to quick filters
										const clonedSection = filterSection.parentElement.cloneNode(true);
										quickFiltersContainer.appendChild(clonedSection);

										// Reveal the options on the single quick-filter click instead of forcing
										// the shopper to click the chevron again. The clone is a plain <details>
										// (it is outside the accordion-disclosure web component), so open it and
										// set aria-expanded directly — the chevron rotation is keyed on aria-expanded.
										clonedSection.setAttribute("open", "");
										clonedSection.setAttribute("aria-expanded", "true");

										// Keep aria-expanded in sync with the native open/close toggle so a single
										// click on the chevron reliably collapses/expands and the arrow rotates.
										clonedSection.addEventListener("toggle", () => {
											clonedSection.setAttribute("aria-expanded", clonedSection.open ? "true" : "false");
										});

										closeFilterDrawer();

										// Set up checkbox handlers
										const checkboxes = clonedSection.querySelectorAll('input[type="checkbox"]');
										checkboxes.forEach((checkbox) => {
											checkbox.addEventListener("change", () => {
												try {
													// Track quick filters - filter interaction
													sendConvertEvent(100462588, "[GTM] Filter Interaction");
													// sendGAEvent("filter_interaction", true);

													// Keep original checkboxes in sync
													const originalCheckbox = filterDrawer.querySelector(`input[id="${checkbox.id}"]`);
													if (originalCheckbox) originalCheckbox.checked = checkbox.checked;

													const filterActionInfo = {
														name: checkbox.name,
														value: checkbox.value,
														selected: checkbox.checked
													};

													applyFilter(quickFiltersContainer, mainCollectionContainer, filterActionInfo);
												} catch (err) {
													if (debugMode) console.error(logInfo, err.message);
												}
											});
										});
									}
								} catch (err) {
									if (debugMode) console.error(logInfo, err.message);
								}
							});
						});
					}
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			};

			// Wait for collection container and initialise quick filters
			waitForElement("main#main .shopify-section--main-collection").then((mainCollectionContainer) => {
				try {
					// Watch for DOM changes and re-add quick filters if needed
					new MutationObserver(() => {
						try {
							addQuickFilters(mainCollectionContainer);
						} catch (err) {
							if (debugMode) console.error(logInfo, err.message);
						}
					}).observe(mainCollectionContainer, {
						childList: true,
						subtree: true
					});

					// Initial quick filters setup
					addQuickFilters(mainCollectionContainer);
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			});
		}
	} catch (err) {
		if (debugMode) console.error(logInfo, err.message);
	}
})();